import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Module } from 'src/app/Service/element-details.data.service';
import { CommonService } from 'src/app/Service/Common.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { IWorkflowStatusInputModel, IWorkflowStatusViewModel } from 'src/app/ViewModel/WorkflowStatusModel';
import { WorkflowStatusCCNDialogComponent } from '../dialogs/workflow-status-ccn-dialog/workflow-status-ccn-dialog.component';
import { WorkflowStatusChecklistDialogComponent } from '../dialogs/workflow-status-checklist-dialog/workflow-status-checklist-dialog.component';
import { WorkflowTenderQuantityComponent } from '../dialogs/workflow-tender-quantity/workflow-tender-quantity.component';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import * as _ from 'lodash';
import { ScheduleWorkflowhistoryComponent } from '../../engineering-schedule/schedule-workflowhistory/schedule-workflowhistory.component';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';


@Component({
  selector: 'app-workflow-status',
  templateUrl: './workflow-status.component.html',
  styleUrls: ['./workflow-status.component.css']
})
export class WorkflowStatusComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public selectedRootIndex = 0;
  public selectedTabIndex = 0;
  public messageId !: null | number;
  public canView: boolean = false;
  public isRedirected: boolean = false;
  public isPending: boolean = true;
  public viewTabs: any[] = [];
  public viewData: any[] = [];
  public searchList: any[] = [];
  public approvedList: any[] = [];
  public forActionList: any[] = [];
  public rejectedList: any[] = [];
  public inProgressList: any[] = [];
  public projectId: null | number = null;
  public groupId: number = 0;
  public memberId: number = 0;
  public documentList: any[] = [];
  public dynamicHeader: any[] = [];
  public data: any[] = [];
  public buttonType = 'MyDocuments';
  public LastViewingRecords = 30;
  workflowStatusView: any[] = [];
  workflowList: IWorkflowStatusViewModel[] = [];
  enableFilter = false;
  public structure: any[] = [];
  public discipline: any[] = [];
  public dwgList: any[] = [];
  public discipline_Id?: null | number;
  public structure_Id?: null | number;
  public drg_Type?: null | string = null;
  public isLatest: boolean = true;
  public _docService: DocumentService;

  Project_Id!: number;
  Group_Id: number = 0;
  selectedChecklistCollection: Array<any> = new Array<any>();

  constructor(
    private encryptDecryptService: EncryptDecryptService,
    public _notificationService: NotificationService,
    public workflowTemplateService: WorkflowTemplateService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private communicationService: CommunicationService,
    private _projInfoService: ProjectInfoService) { this.allData = this.allData.bind(this); }

  ngOnInit() {
    this.Project_Id = this.commonService.getProjectId();
    this.Group_Id = this.commonService.getLoggedInUserGroupId();
    this.getDropDownValue();
    this.getworkflowdetails();
  }

  getDropDownValue() {

    this._projInfoService.getProjectElementDetails({ projectId: this.Project_Id, groupId: this.Group_Id, moduleId: Module.ScheduleDocument, deDescription: 'Discipline' }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.discipline = res;
    });

    this._projInfoService.getProjectElementDetails({ projectId: this.Project_Id, groupId: this.Group_Id, moduleId: Module.ScheduleDocument, deDescription: 'Structure / Package' }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.structure = res;
    });

    this._projInfoService.getProjectElementDetails({ projectId: this.Project_Id, groupId: this.Group_Id, moduleId: Module.ScheduleDocument, deDescription: 'DWG / DOC' }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.dwgList = res;
    });

  }

  viewDocumentClick(data: any) {
    let index = this.viewTabs.indexOf(data);
    if (index == -1) {
      if (!this.canView) {
        this._notificationService.showPopup("You do not have View access. Kindly contact Admin", 'Information');
        return;
      }

      this.viewTabs.push(data);
      this.selectedTabIndex = 1;
    }
  }
  selectedDiscipline(value: any) {
    if (value.value != "-2") {
      this.discipline_Id = value.additionalValues.additionalValues.dedId;
    } else {
      this.discipline_Id = null;
    }
  }

  selectedSturcture(value: any) {
    if (value.value != "-2") {
      this.structure_Id = value.additionalValues.additionalValues.dedId;
    } else {
      this.structure_Id = null;
    }
  }

  selectedDwg(value: any) {
    if (value.value != "-2") {
      this.drg_Type = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.drg_Type = null;
    }
  }

  getworkflowdetails() {
    let obj: IWorkflowStatusInputModel = {
      Project_Id: this.Project_Id,
      Group_Id: this.Group_Id,
      discipline_Id: this.discipline_Id ? this.discipline_Id : undefined,
      structure_Id: this.structure_Id,
      drg_Type: this.drg_Type,
      Search_Text: null,
      isLatest: this.isLatest
    };
    this.workflowTemplateService.GetWorkflowStatusDetails(obj).subscribe((data: IWorkflowStatusViewModel[]) => {
      this.workflowStatusView = data;
    });
  }

  public openTQ(data: IWorkflowStatusViewModel) {
    let dialogRef = this.dialog.open(WorkflowTenderQuantityComponent, {
      panelClass: 'mat-dialog-primary',
      height: '60',
      maxWidth: '60vw',
      autoFocus: false,
      disableClose: true,
      data: { documentId: data.doc_Id, docNo: data.doc_No, revisionNo: data.revision_No, isReadMode: true }
    });
  }

  public onClick_WorkflowCheckList(data: IWorkflowStatusViewModel) {
    let checklist = {
      'workflow_Id': data.workflow_Id,
      'doc_Id': data.doc_Id,
      'doc_No': data.doc_No,
      'documentRevisionNo': data.revision_No
    }
    let dialogRef = this.dialog.open(WorkflowStatusChecklistDialogComponent, {
      panelClass: 'mat-dialog-primary',
      height: '50',
      maxWidth: '60vw',
      autoFocus: false,
      data: checklist
    });
    dialogRef.afterClosed().subscribe(data => {
    });
  }

  public onClick_WorkflowHistory(data: IWorkflowStatusViewModel) {
    let dialogRef = this.dialog.open(ScheduleWorkflowhistoryComponent, {
      panelClass: 'mat-dialog-content',
      data: data,
      maxHeight: '100%'
    });

    dialogRef.afterClosed().subscribe((data) => {
    });
  }

  public viewAttachmentClick(dataItem: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { projectId: this.commonService.getProjectId(), docId: dataItem.doc_Id, revisionNo: null, libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments], createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: false, documentNo: dataItem.doc_No },
    });
  }

  public openCCN(data: IWorkflowStatusViewModel) {
    let dialogRef = this.dialog.open(WorkflowStatusCCNDialogComponent, {
      panelClass: 'mat-dialog-primary',
      height: '50',
      maxWidth: '60vw',
      autoFocus: false,
      data: { doc_Id: data.doc_Id, doc_No: data.doc_No }
    });
    dialogRef.afterClosed().subscribe(data => {
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.workflowStatusView
    };
    return result;
  }
}
